import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin,
  FaFacebook,
} from "react-icons/fa";
import { HiOutlineMail, MiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import Logo from "../assets/Logo.png";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleResize = () => {
      setNav(false);
    };
    mediaQuery.addListener(handleResize);
    return () => {
      mediaQuery.removeListener(handleResize);
    };
  }, []);

  return (
    <div className="fixed z-10 flex h-10 w-full items-center justify-between bg-neutral-900 px-10 py-10 text-gray-300 shadow-md shadow-neutral-900">
      {/*logo*/}
      <div className="logo hover:cursor-pointer">
        <Link to="home" smooth={true} duration={500}>
          <img src={Logo} alt="Logo Image" style={{ width: "72px" }}></img>
        </Link>
      </div>

      {/*menu*/}
      <ul className="hidden md:flex">
        <li>
          <Link to="home" smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li>
          <Link to="about" smooth={true} duration={500}>
            About
          </Link>
        </li>
        {/* <li>
                    <Link to="resume" smooth={true} duration={500}>
                        Resume
                    </Link>
                </li> */}
        <li>
          <Link to="work" smooth={true} duration={500}>
            Work
          </Link>
        </li>
        <li>
          <Link to="contact" smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/*hamburger*/}
      <div onClick={handleClick} className="z-10 md:hidden">
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {/*mobile menu*/}
      <ul
        className={
          nav
            ? "absolute left-0 top-0 flex h-screen w-full flex-col items-center justify-center bg-neutral-900 py-6 text-4xl duration-300"
            : "absolute left-0 top-0 flex h-screen w-full translate-x-full flex-col items-center justify-center bg-neutral-900 py-6 text-4xl duration-300"
        }
      >
        <li className="py-6">
          <Link onClick={handleClick} to="home" smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className="py-6">
          <Link onClick={handleClick} to="about" smooth={true} duration={500}>
            About
          </Link>
        </li>
        {/* <li className='py-6'>
                    <Link onClick={handleClick} to="resume" smooth={true} duration={500}>
                        Resume
                    </Link>
                </li> */}
        <li className="py-6">
          <Link onClick={handleClick} to="work" smooth={true} duration={500}>
            Work
          </Link>
        </li>
        <li className="py-6">
          <Link onClick={handleClick} to="contact" smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
